import FieldOpsNotesModal from "./FieldOpsNotesModal";
export default FieldOpsNotesModal;
